module.exports = {"530521101":"甸阳镇","530521102":"由旺镇","530521103":"姚关镇","530521104":"仁和镇","530521105":"太平镇","530521201":"万兴乡","530521202":"摆榔彝族布朗族乡","530521203":"酒房乡","530521204":"旧城乡","530521205":"木老元布朗族彝族乡","530521206":"老麦乡","530521207":"何元乡","530521208":"水长乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530521.json
// module id = 2710
// module chunks = 0